<app-menu></app-menu>

<section class="controlproject-page" *ngIf="tenantId; else emptyState">
  <header class="page-header" *ngIf="!activeProject">
    <div class="page-guide">CONTROLPS / PROJETOS</div>
  </header>

  <div class="tab-toolbar" *ngIf="!activeProject">
    <div class="cp-tabs project-main-tabs">
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'dashboard'" (click)="setActiveMainTab('dashboard')">
        <mat-icon>dashboard</mat-icon>
        Dashboard
      </button>
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'projects'" (click)="setActiveMainTab('projects')">
        <mat-icon>work_outline</mat-icon>
        Projetos
      </button>
    </div>

    <div class="tab-toolbar__actions">
      <button mat-raised-button color="primary" class="quick-actions-btn" type="button" (click)="openNewProjectModal()">
        <mat-icon>add</mat-icon>
        <span class="quick-actions-btn__label">NOVO PROJETO</span>
      </button>
    </div>
  </div>

  <section class="dashboard-header" *ngIf="!activeProject && activeMainTab === 'dashboard'">
    <div>
      <h2>{{ 'PROJECTS.DASHBOARD_TITLE' | translate }}</h2>
      <p>{{ 'PROJECTS.DASHBOARD_SUBTITLE' | translate }}</p>
    </div>
  </section>

  <section class="project-v2-kpis" *ngIf="!activeProject && activeMainTab === 'dashboard'">
    <article class="project-v2-kpi-card">
      <div class="project-v2-kpi-card__head">
        <span>Projetos (período)</span>
        <mat-icon>work_outline</mat-icon>
      </div>
      <strong>{{ projectNumber(projectDashboardKpis.projectsPeriod) }}</strong>
      <small>Média mensal: {{ projectDecimal(projectInsights.avgCreatedPerMonth) }}</small>
    </article>

    <article class="project-v2-kpi-card">
      <div class="project-v2-kpi-card__head">
        <span>Concluídos (período)</span>
        <mat-icon>task_alt</mat-icon>
      </div>
      <strong>{{ projectNumber(projectDashboardKpis.completedPeriod) }}</strong>
      <small>Média mensal: {{ projectDecimal(projectInsights.avgCompletedPerMonth) }}</small>
    </article>

    <article class="project-v2-kpi-card">
      <div class="project-v2-kpi-card__head">
        <span>Taxa de conclusão</span>
        <mat-icon>insights</mat-icon>
      </div>
      <strong>{{ projectPercent(projectDashboardKpis.completionRate) }}</strong>
      <small>Concluídos / criados no período</small>
    </article>

    <article class="project-v2-kpi-card">
      <div class="project-v2-kpi-card__head">
        <span>Projetos em atraso</span>
        <mat-icon>warning</mat-icon>
      </div>
      <strong>{{ projectNumber(projectDashboardKpis.overdueOpen) }}</strong>
      <small>Projetos abertos com prazo vencido</small>
    </article>
  </section>

  <section class="project-v2-layout" *ngIf="!activeProject && activeMainTab === 'dashboard'">
    <article class="card project-v2-card project-v2-card--evolution">
      <header class="project-v2-card__head">
        <h3>Projetos criados e concluídos por mês</h3>
        <div class="project-period-toggle">
          <button type="button" class="project-period-btn" [class.active]="projectDashboardPeriodMonths === 3" (click)="setProjectDashboardPeriod(3)">3m</button>
          <button type="button" class="project-period-btn" [class.active]="projectDashboardPeriodMonths === 6" (click)="setProjectDashboardPeriod(6)">6m</button>
          <button type="button" class="project-period-btn" [class.active]="projectDashboardPeriodMonths === 12" (click)="setProjectDashboardPeriod(12)">12m</button>
        </div>
      </header>

      <div class="project-v2-line-chart" *ngIf="projectMonthlySeries.length">
        <svg viewBox="0 0 640 230" preserveAspectRatio="none">
          <polyline class="grid-line" points="36,18 36,192 616,192"></polyline>
          <ng-container *ngFor="let tick of projectLineYAxisTicks">
            <line class="grid-line-h" x1="36" x2="616" [attr.y1]="tick.y" [attr.y2]="tick.y"></line>
            <text class="y-axis-label" x="30" [attr.y]="tick.y + 3" text-anchor="end">{{ tick.label }}</text>
          </ng-container>
          <line
            class="line-average"
            x1="36"
            x2="616"
            [attr.y1]="projectLineYByValue(projectCreatedAveragePerMonth)"
            [attr.y2]="projectLineYByValue(projectCreatedAveragePerMonth)">
            <title>Média no período: {{ projectCreatedAveragePerMonthLabel }} projetos/mês</title>
          </line>
          <text
            class="line-average-label"
            x="612"
            [attr.y]="projectLineYByValue(projectCreatedAveragePerMonth) - 6"
            text-anchor="end">
            Média {{ projectCreatedAveragePerMonthLabel }}/mês
          </text>

          <polyline
            class="line line-primary"
            [attr.points]="projectLinePointList(projectCreatedSeriesValues)">
          </polyline>
          <polyline
            class="line line-secondary"
            [attr.points]="projectLinePointList(projectCompletedSeriesValues)">
          </polyline>

          <ng-container *ngFor="let point of projectLineDots(projectCreatedSeriesValues)">
            <circle
              class="dot dot-primary"
              [attr.cx]="point.x"
              [attr.cy]="point.y"
              r="5"
              (mouseenter)="projectLinePointEnter($event, point, 'created')"
              (mousemove)="projectLinePointMove($event, point, 'created')"
              (mouseleave)="projectLinePointLeave()">
            </circle>
          </ng-container>

          <ng-container *ngFor="let point of projectLineDots(projectCompletedSeriesValues)">
            <circle
              class="dot dot-secondary"
              [attr.cx]="point.x"
              [attr.cy]="point.y"
              r="4.2"
              (mouseenter)="projectLinePointEnter($event, point, 'completed')"
              (mousemove)="projectLinePointMove($event, point, 'completed')"
              (mouseleave)="projectLinePointLeave()">
            </circle>
          </ng-container>
        </svg>

        <div
          class="project-v2-chart-tooltip"
          *ngIf="projectLineTooltip.visible"
          [style.left.px]="projectLineTooltip.x"
          [style.top.px]="projectLineTooltip.y">
          <strong>{{ projectLineTooltip.title }}</strong>
          <small>{{ projectLineTooltip.value }}</small>
        </div>

        <div class="project-v2-line-chart__labels" [style.gridTemplateColumns]="'repeat(' + projectMonthlySeries.length + ', 1fr)'">
          <span *ngFor="let item of projectMonthlySeries">{{ item.label }}</span>
        </div>
      </div>

      <div class="project-v2-legend project-v2-line-legend">
        <span><i class="legend-dot legend-dot--primary"></i>Criados</span>
        <span><i class="legend-dot legend-dot--secondary"></i>Concluídos</span>
        <span><i class="legend-line legend-line--average"></i>Média {{ projectCreatedAveragePerMonthLabel }}/mês</span>
      </div>
    </article>

    <article class="card project-v2-card project-v2-card--types">
      <header class="project-v2-card__head">
        <h3>Distribuição por status</h3>
        <span>{{ projectStatusRows.length }} status</span>
      </header>

      <div class="project-v2-type-donut-wrap" *ngIf="projectStatusRows.length; else emptyStatus">
        <div class="project-v2-donut-wrap">
          <div class="project-v2-donut" [style.background]="projectStatusDonutStyle">
            <div class="project-v2-donut__inner">
              <strong>{{ projectNumber(projectInsights.totalProjects) }}</strong>
              <small>projetos</small>
            </div>
          </div>
        </div>

        <div class="project-v2-status-bars">
          <div class="project-v2-status-row" *ngFor="let row of projectStatusRows">
            <div class="project-v2-status-row__head">
              <span>{{ row.label }}</span>
              <strong>{{ projectNumber(row.count) }} · {{ row.percent }}%</strong>
            </div>
            <div class="mini-bar">
              <div class="mini-bar__fill" [style.width.%]="row.percent" [style.background]="row.color"></div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyStatus>
        <div class="empty">Sem projetos para distribuição.</div>
      </ng-template>
    </article>

    <article class="card project-v2-card project-v2-card--top">
      <header class="project-v2-card__head">
        <h3>Top gerentes por volume</h3>
        <span>Projetos por responsável</span>
      </header>
      <div class="project-v2-status-bars">
        <div class="project-v2-status-row" *ngFor="let row of projectManagerRows">
          <div class="project-v2-status-row__head">
            <span>{{ row.label }}</span>
            <strong>{{ projectNumber(row.count) }} · {{ row.percent }}%</strong>
          </div>
          <div class="mini-bar">
            <div class="mini-bar__fill mini-bar__fill--managers" [style.width.%]="row.percent"></div>
          </div>
        </div>
        <div class="empty" *ngIf="!projectManagerRows.length">Sem dados no período selecionado.</div>
      </div>
    </article>

    <article class="card project-v2-card project-v2-card--insights">
      <header class="project-v2-card__head">
        <h3>Distribuição por departamento</h3>
        <span>{{ projectDepartmentRows.length }} departamento(s)</span>
      </header>

      <div class="project-v2-type-donut-wrap" *ngIf="projectDepartmentRows.length; else emptyDepartment">
        <div class="project-v2-donut-wrap">
          <div class="project-v2-donut" [style.background]="projectDepartmentDonutStyle">
            <div class="project-v2-donut__inner">
              <strong>{{ projectNumber(projectInsights.totalProjects) }}</strong>
              <small>projetos</small>
            </div>
          </div>
        </div>

        <div class="project-v2-status-bars">
          <div class="project-v2-status-row" *ngFor="let row of projectDepartmentRows">
            <div class="project-v2-status-row__head">
              <span>{{ row.label }}</span>
              <strong>{{ projectNumber(row.count) }} · {{ row.percent }}%</strong>
            </div>
            <div class="mini-bar">
              <div class="mini-bar__fill" [style.width.%]="row.percent" [style.background]="row.color"></div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyDepartment>
        <div class="empty">Sem projetos para distribuição por departamento.</div>
      </ng-template>
    </article>
  </section>

  <section class="dashboard-header" *ngIf="!activeProject && activeMainTab === 'projects'">
    <div>
      <h2>Projetos</h2>
      <p>Busque, filtre e acompanhe o andamento dos projetos.</p>
    </div>
  </section>

  <section class="panel filters" *ngIf="!activeProject && activeMainTab === 'projects'">
    <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field project-filter-field project-filter-field--search">
      <mat-label>{{ 'PROJECTS.SEARCH_PLACEHOLDER' | translate }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput type="search" [(ngModel)]="searchTerm" name="project_search" (ngModelChange)="loadProjects()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field project-filter-field">
      <mat-label>Ordenar por</mat-label>
      <mat-select [(ngModel)]="sortOption" name="project_sort" (selectionChange)="onProjectFiltersChange()">
        <mat-option value="CREATED_DESC">{{ 'PROJECTS.SORT.CREATED' | translate }}</mat-option>
        <mat-option value="NAME_ASC">{{ 'PROJECTS.SORT.NAME' | translate }}</mat-option>
        <mat-option value="UPDATED_DESC">{{ 'PROJECTS.SORT.UPDATED' | translate }}</mat-option>
        <mat-option value="STATUS_ASC">{{ 'PROJECTS.SORT.STATUS' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field project-filter-field">
      <mat-label>Escopo</mat-label>
      <mat-select [(ngModel)]="ownershipFilter" name="project_ownership" (selectionChange)="onProjectFiltersChange()">
        <mat-option value="ALL">{{ 'PROJECTS.FILTER.ALL' | translate }}</mat-option>
        <mat-option value="MINE">{{ 'PROJECTS.FILTER.MINE' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field project-filter-field">
      <mat-label>Status</mat-label>
      <mat-select multiple [(ngModel)]="statusFilters" name="project_status_filter" (selectionChange)="onProjectFiltersChange()">
        <mat-select-trigger>
          <ng-container *ngIf="statusFilters.includes('ALL'); else projectStatusSelected">
            Todos
          </ng-container>
          <ng-template #projectStatusSelected>
            {{ statusFilters.length ? statusLabel(statusFilters[0]) : ('PROJECTS.STATUS.ALL' | translate) }}
            <span *ngIf="statusFilters.length > 1">+{{ statusFilters.length - 1 }}</span>
          </ng-template>
        </mat-select-trigger>
        <mat-option value="ALL">Todos</mat-option>
        <mat-option value="DRAFT">{{ 'PROJECTS.STATUS.DRAFT' | translate }}</mat-option>
        <mat-option value="PLANNED">{{ 'PROJECTS.STATUS.PLANNED' | translate }}</mat-option>
        <mat-option value="IN_PROGRESS">{{ 'PROJECTS.STATUS.IN_PROGRESS' | translate }}</mat-option>
        <mat-option value="PAUSED">{{ 'PROJECTS.STATUS.PAUSED' | translate }}</mat-option>
        <mat-option value="COMPLETED">{{ 'PROJECTS.STATUS.COMPLETED' | translate }}</mat-option>
        <mat-option value="CANCELED">{{ 'PROJECTS.STATUS.CANCELED' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button
      type="button"
      class="status-pin-toggle"
      [class.active]="statusFiltersPinned"
      (click)="toggleStatusFilterPin()">
      <mat-icon>{{ statusFiltersPinned ? 'push_pin' : 'push_pin_outlined' }}</mat-icon>
      <span>{{ statusFiltersPinned ? 'Fixado' : 'Fixar' }}</span>
    </button>
  </section>

  <section class="project-grid" *ngIf="!activeProject && activeMainTab === 'projects'">
    <article class="project-card" *ngFor="let project of paginatedFilteredProjects" (click)="openProject(project)">
      <div class="project-main">
        <div>
          <strong>{{ project.name }}</strong>
          <small>{{ project.code || ('PROJECTS.CARD.NO_CODE' | translate) }}</small>
        </div>
        <div class="project-actions">
          <span class="status-pill" [class]="project.status.toLowerCase()">{{ statusLabel(project.status) }}</span>
          <button class="icon-button danger" type="button" (click)="deleteProject(project, $event)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <div class="project-meta">
        <span>{{ 'PROJECTS.CARD.MANAGER' | translate }}: {{ project.manager_name || ('PROJECTS.CARD.NOT_DEFINED' | translate) }}</span>
        <span>{{ 'PROJECTS.CARD.PERIOD' | translate }}: {{ project.start_date | date:'dd/MM/yyyy' }} · {{ project.end_date | date:'dd/MM/yyyy' }}</span>
        <span>{{ 'PROJECTS.CARD.TEAM' | translate }}: {{ project.members_count || 0 }} {{ 'PROJECTS.CARD.PEOPLE' | translate }}</span>
        <span>{{ 'PROJECTS.CARD.DEPARTMENT' | translate }}: {{ project.department_name || '—' }}</span>
        <span>{{ 'PROJECTS.CARD.LAST_UPDATE' | translate }}: {{ projectLastUpdateLabelFor(project) }}</span>
      </div>
    </article>
    <p class="empty" *ngIf="!filteredProjects.length">Nenhum projeto encontrado.</p>

    <div class="project-pagination" *ngIf="filteredProjects.length">
      <span class="project-pagination__meta">
        Mostrando {{ projectPageStart }}-{{ projectPageEnd }} de {{ filteredProjects.length }}
      </span>
      <div class="project-pagination__actions" *ngIf="projectTotalPages > 1">
        <button type="button" class="project-pagination__btn" (click)="prevProjectPage()" [disabled]="projectCurrentPage <= 1">
          Anterior
        </button>
        <span class="project-pagination__page">{{ projectCurrentPage }} / {{ projectTotalPages }}</span>
        <button type="button" class="project-pagination__btn" (click)="nextProjectPage()" [disabled]="projectCurrentPage >= projectTotalPages">
          Próxima
        </button>
      </div>
    </div>
  </section>

  <section class="project-detail" *ngIf="activeProject">
    <div class="detail-breadcrumb">Projetos / Gestão</div>

    <div class="detail-header">
      <div class="detail-header__title">
        <div class="detail-header__title-row">
          <ng-container *ngIf="!editingProjectTitle; else inlineProjectTitleEditor">
            <h2>{{ activeProject.name }}</h2>
            <button
              type="button"
              class="detail-header__edit-btn"
              (click)="startProjectTitleEdit()"
              aria-label="Editar título do projeto">
              <mat-icon class="detail-header__edit-icon">edit</mat-icon>
            </button>
          </ng-container>
          <ng-template #inlineProjectTitleEditor>
            <div class="detail-header__title-editor">
              <input
                type="text"
                [(ngModel)]="projectTitleDraft"
                (keydown.enter)="saveProjectTitleEdit()"
                (keydown.escape)="cancelProjectTitleEdit()"
                [disabled]="savingProjectTitle"
                maxlength="180"
                placeholder="Nome do projeto" />
              <button type="button" (click)="saveProjectTitleEdit()" [disabled]="savingProjectTitle" aria-label="Salvar título">
                <mat-icon>check</mat-icon>
              </button>
              <button type="button" (click)="cancelProjectTitleEdit()" [disabled]="savingProjectTitle" aria-label="Cancelar edição de título">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </ng-template>
        </div>
        <div class="detail-header__description">
          <ng-container *ngIf="!editingProjectDescription; else inlineProjectDescriptionEditor">
            <p
              class="detail-header__description-text"
              [class.is-expanded]="projectDescriptionExpanded"
              [class.has-toggle]="showProjectDescriptionToggle">
              {{ activeProject.description || 'Sem descrição do projeto.' }}
            </p>
            <button
              *ngIf="hasProjectDescription && showProjectDescriptionToggle"
              type="button"
              class="detail-header__toggle-btn"
              (click)="toggleProjectDescriptionExpanded()">
              {{ projectDescriptionExpanded ? 'ver menos' : 'ver mais' }}
            </button>
            <button
              type="button"
              class="detail-header__edit-btn detail-header__edit-btn--description"
              (click)="startProjectDescriptionEdit()"
              aria-label="Editar descrição do projeto">
              <mat-icon class="detail-header__edit-icon">edit</mat-icon>
            </button>
          </ng-container>
          <ng-template #inlineProjectDescriptionEditor>
            <div class="detail-header__description-editor">
              <textarea
                [(ngModel)]="projectDescriptionDraft"
                [disabled]="savingProjectDescription"
                rows="3"
                placeholder="Descrição do projeto"></textarea>
              <button type="button" (click)="saveProjectDescriptionEdit()" [disabled]="savingProjectDescription" aria-label="Salvar descrição">
                <mat-icon>check</mat-icon>
              </button>
              <button type="button" (click)="cancelProjectDescriptionEdit()" [disabled]="savingProjectDescription" aria-label="Cancelar edição de descrição">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </ng-template>
        </div>
        <div class="detail-header__meta">
          <span class="detail-project-code">{{ activeProject.code || 'Sem código' }}</span>
          <span class="status-pill" [class]="activeProject.status.toLowerCase()">{{ statusLabel(activeProject.status) }}</span>
        </div>
      </div>

      <div class="detail-header__actions">
        <button
          mat-stroked-button
          type="button"
          class="detail-panel-trigger"
          (click)="goToProjectMainPanel()">
          <mat-icon>dashboard</mat-icon>
          <span class="quick-actions-btn__label">PAINEL</span>
        </button>

        <button
          mat-raised-button
          color="primary"
          type="button"
          class="quick-actions-btn detail-action-trigger"
          [matMenuTriggerFor]="projectDetailActionsMenu">
          <mat-icon>add</mat-icon>
          <span class="quick-actions-btn__label">AÇÕES</span>
        </button>
      </div>

      <mat-menu #projectDetailActionsMenu="matMenu" xPosition="before" class="controlproject-detail-menu">
        <button mat-menu-item type="button" (click)="startProjectDescriptionEdit()">
          <mat-icon>description</mat-icon>
          <span>Editar descrição</span>
        </button>
        <button mat-menu-item type="button" (click)="openDateEditModal()">
          <mat-icon>event</mat-icon>
          <span>Alterar datas</span>
        </button>
        <button mat-menu-item type="button" (click)="deleteProject(activeProject)" class="menu-item-danger">
          <mat-icon>delete</mat-icon>
          <span>Excluir projeto</span>
        </button>
        <button mat-menu-item type="button" (click)="closeProject()">
          <mat-icon>arrow_back</mat-icon>
          <span>Voltar</span>
        </button>
      </mat-menu>
    </div>

    <div class="detail-summary">
      <article class="summary-card summary-card--manager">
        <span class="summary-card__label">
          <mat-icon>person</mat-icon>
          Gerente
        </span>
        <div class="summary-user">
          <span class="summary-user__avatar">{{ projectPersonInitials(activeProject.manager_name) }}</span>
          <div class="summary-user__meta">
            <div class="summary-user__name-row">
              <strong>{{ activeProject.manager_name || 'Não definido' }}</strong>
              <span class="summary-user__donut" [style.background]="projectManagerDonutStyle">
                <span>{{ projectCompletionPercent }}%</span>
              </span>
            </div>
            <small>Responsável pelo projeto</small>
          </div>
        </div>
      </article>

      <article class="summary-card summary-card--status">
        <span class="summary-card__label">
          <mat-icon>calendar_today</mat-icon>
          Status atual
        </span>
        <div class="summary-status-row">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field detail-status-field">
            <mat-select [ngModel]="activeProject.status" (ngModelChange)="updateProjectStatus($event)">
              <mat-option value="DRAFT">Rascunho</mat-option>
              <mat-option value="PLANNED">Planejado</mat-option>
              <mat-option value="IN_PROGRESS">Em andamento</mat-option>
              <mat-option value="PAUSED">Pausado</mat-option>
              <mat-option value="COMPLETED">Concluído</mat-option>
              <mat-option value="CANCELED">Cancelado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </article>

      <article class="summary-card summary-card--period">
        <span class="summary-card__label">
          <mat-icon>schedule</mat-icon>
          Período
        </span>
        <div class="summary-period-grid">
          <div>
            <small class="summary-period-grid__label">Início</small>
            <strong>{{ activeProject.start_date | date:'dd/MM/yyyy' }}</strong>
          </div>
          <div>
            <small class="summary-period-grid__label">Fim</small>
            <strong>{{ activeProject.end_date | date:'dd/MM/yyyy' }}</strong>
          </div>
        </div>
      </article>
    </div>

    <div class="detail-layout">
      <div class="detail-main">
        <nav class="cp-tabs detail-tabs">
          <button mat-stroked-button type="button" [class.active]="detailTab === 'calendar'" (click)="detailTab = 'calendar'">
            <mat-icon>calendar_month</mat-icon>
            Calendário
          </button>
          <button mat-stroked-button type="button" [class.active]="detailTab === 'tasks'" (click)="detailTab = 'tasks'">
            <mat-icon>task_alt</mat-icon>
            Tarefas
          </button>
          <button mat-stroked-button type="button" [class.active]="detailTab === 'tickets'" (click)="detailTab = 'tickets'">
            <mat-icon>support_agent</mat-icon>
            Chamados
          </button>
          <button mat-stroked-button type="button" [class.active]="detailTab === 'tap'" (click)="detailTab = 'tap'">
            <mat-icon>description</mat-icon>
            TAP
          </button>
          <button mat-stroked-button type="button" [class.active]="detailTab === 'team'" (click)="detailTab = 'team'">
            <mat-icon>groups</mat-icon>
            Equipe
          </button>
          <button mat-stroked-button type="button" [class.active]="detailTab === 'attachments'" (click)="detailTab = 'attachments'">
            <mat-icon>attach_file</mat-icon>
            Anexos
          </button>
        </nav>

        <div class="detail-content detail-panel" *ngIf="detailTab === 'calendar'">
          <div class="calendar-header">
            <button class="btn ghost" type="button" (click)="prevMonth()">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <h3>{{ calendarMonth | date:'MMMM yyyy' }}</h3>
            <button class="btn ghost" type="button" (click)="nextMonth()">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>

          <div class="calendar-weekdays">
            <span>Dom</span>
            <span>Seg</span>
            <span>Ter</span>
            <span>Qua</span>
            <span>Qui</span>
            <span>Sex</span>
            <span>Sáb</span>
          </div>

          <div class="calendar-grid">
            <div class="calendar-day" *ngFor="let day of calendarDays" [class.outside]="!day.isCurrentMonth" [class.range]="isProjectRange(day.date)">
              <span class="day-label">{{ day.label }}</span>
              <div class="calendar-tags">
                <span class="dot milestone" *ngIf="milestoneCount(day.date)">{{ milestoneCount(day.date) }}</span>
                <span class="dot task" *ngIf="taskCount(day.date)">{{ taskCount(day.date) }}</span>
              </div>
              <ng-container *ngIf="tasksForDate(day.date) as dayTasks">
                <div class="calendar-tasks" *ngIf="dayTasks.length">
                  <div
                    class="calendar-task"
                    *ngFor="let task of dayTasks | slice:0:3"
                    [class.start]="isTaskStart(day.date, task)"
                    [class.end]="isTaskEnd(day.date, task)"
                    [class.single]="isTaskSingleDay(task)">
                    {{ task.title }}
                  </div>
                  <small class="calendar-more" *ngIf="dayTasks.length > 3">+{{ dayTasks.length - 3 }} tarefas</small>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="calendar-footer">
            <button class="quick-actions-btn detail-new-milestone-btn" type="button" (click)="openMilestoneModal()">
              <mat-icon>add</mat-icon>
              <span class="quick-actions-btn__label">NOVO MARCO</span>
            </button>
          </div>

          <div class="milestone-list">
            <h4>Marcos do projeto</h4>
            <div class="milestone-card" *ngFor="let milestone of milestones">
              <div class="milestone-card__main">
                <strong>{{ milestone.title }}</strong>
                <small>{{ milestone.due_date | date:'dd/MM/yyyy' }}</small>
              </div>
              <div class="milestone-card__actions">
                <span class="status-pill">{{ milestone.status }}</span>
                <button class="icon-button danger" type="button" (click)="deleteMilestone(milestone, $event)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <p class="empty" *ngIf="!milestones.length">Nenhum marco cadastrado.</p>
          </div>
        </div>

        <div class="detail-content detail-panel" *ngIf="detailTab === 'tasks'">
          <div class="detail-actions detail-actions--tasks">
            <span>Tarefas do projeto</span>
            <div class="inline-actions">
              <mat-form-field appearance="outline" class="task-list-filter-field">
                <mat-label>Exibir</mat-label>
                <mat-select [(ngModel)]="projectTaskView" (selectionChange)="refreshVisibleProjectTasks()">
                  <mat-option value="PENDING">Pendentes</mat-option>
                  <mat-option value="COMPLETED">Concluídas</mat-option>
                  <mat-option value="ALL">Todas</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="task-list-filter-field task-list-sort-field">
                <mat-label>Ordenar por</mat-label>
                <mat-select [(ngModel)]="projectTaskSort" (selectionChange)="refreshVisibleProjectTasks()">
                  <mat-option value="DUE_ASC">Prazo mais próximo</mat-option>
                  <mat-option value="DUE_DESC">Prazo mais distante</mat-option>
                  <mat-option value="UPDATED_DESC">Atualização mais recente</mat-option>
                  <mat-option value="RESPONSIBLE_ASC">Responsável (A–Z)</mat-option>
                  <mat-option value="PRIORITY_DESC">Maior prioridade</mat-option>
                </mat-select>
              </mat-form-field>
              <button mat-stroked-button type="button" (click)="openTaskModal()">
                <mat-icon>add</mat-icon>
                Nova tarefa
              </button>
            </div>
          </div>
          <article class="task-list-card" *ngFor="let task of visibleProjectTasks; trackBy: trackByTaskId" (click)="openTaskDetail(task)">
            <div class="task-list-card__main">
              <strong>{{ task.title }}</strong>
              <div class="task-list-card__meta">
                <span class="task-code">#{{ task.task_code || '—' }}</span>
                <span class="task-pill task-pill--status" [ngClass]="(task.status || '').toLowerCase()">
                  {{ taskStatusLabel(task.status) }}
                </span>
                <span class="task-pill task-pill--priority" [ngClass]="(task.priority || '').toLowerCase()">
                  {{ taskPriorityLabel(task.priority) }}
                </span>
                <span class="task-list-card__assignee">
                  <mat-icon>person_outline</mat-icon>
                  Responsável: {{ taskAssigneeLabel(task) }}
                </span>
              </div>
            </div>
            <div class="task-list-card__dates">
              <span>Prazo: {{ task.due_date ? (task.due_date | date:'dd/MM/yyyy') : '—' }}</span>
              <span class="task-deadline" [ngClass]="taskDeadlineClass(task)">
                {{ taskDeadlineLabel(task) }}
              </span>
              <small>Atualização: {{ taskLastUpdateLabel(task) }}</small>
            </div>
          </article>
          <p class="empty" *ngIf="!visibleProjectTasks.length">
            {{ projectTaskView === 'COMPLETED' ? 'Nenhuma tarefa concluída.' : projectTaskView === 'ALL' ? 'Nenhuma tarefa vinculada.' : 'Nenhuma tarefa pendente.' }}
          </p>
        </div>

        <div class="detail-content detail-panel" *ngIf="detailTab === 'tickets'">
          <div class="detail-actions detail-actions--tickets">
            <span>Chamados vinculados ao projeto</span>
            <div class="inline-actions">
              <button mat-stroked-button type="button" (click)="openNewTicket()">
                <mat-icon>add</mat-icon>
                Novo chamado
              </button>
            </div>
          </div>
          <article class="ticket-list-card" *ngFor="let ticket of tickets" (click)="openTicketDetail(ticket)">
            <div class="ticket-list-card__main">
              <strong>{{ ticket.title }}</strong>
              <div class="ticket-list-card__meta">
                <span class="ticket-code">#{{ ticket.ticket_code || '—' }}</span>
                <span class="ticket-pill ticket-pill--status" [ngClass]="(ticket.status || '').toLowerCase()">
                  {{ ticketStatusLabel(ticket.status) }}
                </span>
                <span class="ticket-pill ticket-pill--priority" [ngClass]="(ticket.priority || '').toLowerCase()">
                  {{ ticketPriorityLabel(ticket.priority) }}
                </span>
              </div>
            </div>
            <div class="ticket-list-card__dates">
              <span>Abertura: {{ ticket.opened_at ? (ticket.opened_at | date:'dd/MM/yyyy') : '—' }}</span>
              <small>Atualização: {{ (ticket.last_action_at || ticket.opened_at) | date:'dd/MM/yyyy HH:mm' }}</small>
            </div>
            <div class="ticket-list-card__actions" *ngIf="canDeleteTicket(ticket)">
              <button class="icon-button danger" type="button" [disabled]="deletingTicketId === ticket.id" (click)="deleteTicket(ticket, $event)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </article>
          <p class="empty" *ngIf="!tickets.length">Nenhum chamado vinculado.</p>
        </div>

        <div class="detail-content detail-panel tap" *ngIf="detailTab === 'tap'">
          <div class="detail-actions detail-actions--tap">
            <span>Versões do TAP</span>
            <button mat-raised-button color="primary" class="cp-tap-new-version-btn" type="button" (click)="openTapModal()">
              <mat-icon>add</mat-icon>
              Nova versão
            </button>
          </div>
          <article class="tap-version" *ngFor="let tap of tapVersions">
            <header>
              <div class="tap-version__title">
                <strong>Versão {{ tap.version_number }} · {{ tap.title || 'Sem título' }}</strong>
                <small>Atualizado em {{ tap.created_at | date:'dd/MM/yyyy HH:mm' }}</small>
              </div>
              <div class="tap-actions">
                <button mat-stroked-button class="cp-tap-edit-btn" type="button" (click)="openTapEdit(tap)">Editar TAP</button>
              </div>
            </header>
            <div class="tap-grid">
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'objectives')">
                <h5>Objetivos</h5>
                <p>{{ tap.objectives || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.objectives)"
                  (click)="toggleTapFieldExpanded(tap.id, 'objectives')">
                  {{ isTapFieldExpanded(tap.id, 'objectives') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'justification')">
                <h5>Justificativa</h5>
                <p>{{ tap.justification || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.justification)"
                  (click)="toggleTapFieldExpanded(tap.id, 'justification')">
                  {{ isTapFieldExpanded(tap.id, 'justification') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'business_scope')">
                <h5>Escopo de negócio</h5>
                <p>{{ tap.business_scope || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.business_scope)"
                  (click)="toggleTapFieldExpanded(tap.id, 'business_scope')">
                  {{ isTapFieldExpanded(tap.id, 'business_scope') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'technical_scope')">
                <h5>Escopo técnico</h5>
                <p>{{ tap.technical_scope || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.technical_scope)"
                  (click)="toggleTapFieldExpanded(tap.id, 'technical_scope')">
                  {{ isTapFieldExpanded(tap.id, 'technical_scope') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'deliverables')">
                <h5>Entregas</h5>
                <p>{{ tap.deliverables || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.deliverables)"
                  (click)="toggleTapFieldExpanded(tap.id, 'deliverables')">
                  {{ isTapFieldExpanded(tap.id, 'deliverables') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'non_deliverables')">
                <h5>Fora do escopo</h5>
                <p>{{ tap.non_deliverables || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.non_deliverables)"
                  (click)="toggleTapFieldExpanded(tap.id, 'non_deliverables')">
                  {{ isTapFieldExpanded(tap.id, 'non_deliverables') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'permissions')">
                <h5>Permissões</h5>
                <p>{{ tap.permissions || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.permissions)"
                  (click)="toggleTapFieldExpanded(tap.id, 'permissions')">
                  {{ isTapFieldExpanded(tap.id, 'permissions') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'constraints')">
                <h5>Restrições</h5>
                <p>{{ tap.constraints || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.constraints)"
                  (click)="toggleTapFieldExpanded(tap.id, 'constraints')">
                  {{ isTapFieldExpanded(tap.id, 'constraints') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'assumptions')">
                <h5>Premissas</h5>
                <p>{{ tap.assumptions || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.assumptions)"
                  (click)="toggleTapFieldExpanded(tap.id, 'assumptions')">
                  {{ isTapFieldExpanded(tap.id, 'assumptions') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'risks')">
                <h5>Riscos</h5>
                <p>{{ tap.risks || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.risks)"
                  (click)="toggleTapFieldExpanded(tap.id, 'risks')">
                  {{ isTapFieldExpanded(tap.id, 'risks') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'success_criteria')">
                <h5>Critérios de sucesso</h5>
                <p>{{ tap.success_criteria || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.success_criteria)"
                  (click)="toggleTapFieldExpanded(tap.id, 'success_criteria')">
                  {{ isTapFieldExpanded(tap.id, 'success_criteria') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <div class="tap-grid-item" [class.expanded]="isTapFieldExpanded(tap.id, 'budget')">
                <h5>Orçamento</h5>
                <p>{{ tap.budget || '—' }}</p>
                <button
                  type="button"
                  class="tap-see-more"
                  *ngIf="canTapFieldExpand(tap.budget)"
                  (click)="toggleTapFieldExpanded(tap.id, 'budget')">
                  {{ isTapFieldExpanded(tap.id, 'budget') ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
            </div>
          </article>
          <p class="empty" *ngIf="!tapVersions.length">Nenhuma versão de TAP cadastrada.</p>
        </div>

        <div class="detail-content detail-panel team" *ngIf="detailTab === 'team'">
          <div class="detail-actions detail-actions--team">
            <span>Equipe do projeto</span>
            <button mat-raised-button color="primary" type="button" class="team-add-btn" (click)="openMemberModal()">
              <mat-icon>person_add</mat-icon>
              Adicionar pessoa
            </button>
          </div>
          <article class="team-member-card" *ngFor="let member of projectMembers">
            <div class="team-member-card__main">
              <div class="team-member-avatar" [class.has-photo]="!!memberAvatarUrl(member)">
                <ng-container *ngIf="memberAvatarUrl(member) as avatarUrl; else memberInitialsTpl">
                  <img [src]="avatarUrl" [alt]="'Foto de ' + memberDisplayName(member)">
                </ng-container>
                <ng-template #memberInitialsTpl>{{ projectPersonInitials(memberDisplayName(member)) }}</ng-template>
              </div>
              <div class="team-member-card__meta">
                <div class="team-member-card__title">
                  <strong>{{ memberDisplayName(member) }}</strong>
                  <span class="team-role-pill" [class.manager]="member.role === 'MANAGER'" [class.observer]="member.role === 'OBSERVER'">
                    {{ memberRoleLabel(member.role) }}
                  </span>
                </div>
                <small>{{ memberDepartmentLabel(member) }}</small>
              </div>
            </div>
            <button mat-stroked-button type="button" class="team-member-remove-btn" (click)="removeMember(member)">Remover</button>
          </article>
          <p class="empty" *ngIf="!projectMembers.length">Nenhum membro cadastrado.</p>
        </div>

        <div class="detail-content detail-panel attachments" *ngIf="detailTab === 'attachments'">
          <div class="detail-actions detail-actions--attachments">
            <span>Anexos do projeto</span>
            <button mat-raised-button color="primary" type="button" class="project-attachment-add-btn" (click)="projectAttachmentInput.click()">
              <mat-icon>add</mat-icon>
              ADD ANEXO
            </button>
            <input
              #projectAttachmentInput
              type="file"
              class="hidden-input"
              multiple
              (change)="onProjectAttachmentFileSelected($event)">
          </div>

          <div class="project-attachment-list" *ngIf="projectAttachments.length; else emptyProjectAttachments">
            <article class="project-attachment-item" *ngFor="let item of projectAttachments">
              <div class="project-attachment-thumb">
                <ng-container *ngIf="item.is_image && attachmentFileUrl(item); else fileIconTpl">
                  <img [src]="attachmentFileUrl(item)" [alt]="item.file_name">
                </ng-container>
                <ng-template #fileIconTpl>
                  <mat-icon>description</mat-icon>
                </ng-template>
              </div>
              <div class="project-attachment-meta">
                <strong>
                  <a [href]="attachmentFileUrl(item)" target="_blank" rel="noopener noreferrer">{{ item.file_name }}</a>
                </strong>
                <small>{{ formatFileSize(item.file_size) }} · {{ item.uploaded_at | date:'dd/MM/yyyy HH:mm' }}</small>
              </div>
              <button mat-stroked-button type="button" class="project-attachment-remove-btn" (click)="removeProjectAttachment(item.id)">
                Excluir anexo
              </button>
            </article>
          </div>
          <ng-template #emptyProjectAttachments>
            <p class="empty">Nenhum anexo enviado.</p>
          </ng-template>
        </div>

      </div>

      <aside class="detail-sidebar">
        <header class="detail-sidebar__head">
          <h3>Histórico</h3>
          <span>{{ filteredHistoryTimeline.length }}<ng-container *ngIf="filteredHistoryTimeline.length !== historyTimeline.length"> de {{ historyTimeline.length }}</ng-container></span>
        </header>

        <div class="detail-sidebar__controls">
          <mat-icon>search</mat-icon>
          <input
            type="search"
            [(ngModel)]="historySidebarSearchTerm"
            (ngModelChange)="onHistorySidebarSearchChange()"
            placeholder="Pesquisar no histórico..."
            aria-label="Pesquisar no histórico" />
        </div>

        <div class="detail-sidebar__timeline" *ngIf="filteredHistoryTimeline.length; else emptySidebarHistory">
          <article class="timeline-item" *ngFor="let item of paginatedHistoryTimeline">
            <div class="timeline-item__avatar">{{ projectPersonInitials(item.userName || 'Sistema') }}</div>
            <div class="timeline-item__content">
              <small>{{ item.date ? (item.date | date:'dd/MM/yyyy HH:mm') : '—' }}</small>
              <p><strong>{{ item.userName || 'Sistema' }}</strong> {{ item.title }}</p>
              <p class="timeline-item__detail" *ngIf="item.details">{{ item.details }}</p>
              <p class="timeline-item__description" *ngIf="item.description">{{ item.description }}</p>
              <span class="history-tag" [class]="item.type.toLowerCase()">{{ historyTypeLabel(item.type) }}</span>
            </div>
          </article>
        </div>
        <footer class="detail-sidebar__pagination" *ngIf="filteredHistoryTimeline.length">
          <span>{{ historySidebarPageStart }}-{{ historySidebarPageEnd }} de {{ filteredHistoryTimeline.length }}</span>
          <div class="detail-sidebar__pagination-actions">
            <button type="button" (click)="prevHistorySidebarPage()" [disabled]="historySidebarCurrentPage <= 1">Anterior</button>
            <small>{{ historySidebarCurrentPage }} / {{ historySidebarTotalPages }}</small>
            <button type="button" (click)="nextHistorySidebarPage()" [disabled]="historySidebarCurrentPage >= historySidebarTotalPages">Próxima</button>
          </div>
        </footer>
        <ng-template #emptySidebarHistory>
          <p class="empty">{{ historySidebarSearchTerm ? 'Nenhum item encontrado para o filtro informado.' : 'Nenhum histórico registrado.' }}</p>
        </ng-template>
      </aside>
    </div>
  </section>
</section>

<ng-template #emptyState>
  <div class="empty-state-full">Selecione um tenant para visualizar os projetos.</div>
</ng-template>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showNewProjectModal" (click)="closeNewProjectModal()"></div>
<section class="modal-card cp-modal-fixed-height project-modal cp-project-new-modal" *ngIf="showNewProjectModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ editingDraftId ? 'Editar projeto' : 'Novo projeto' }}</h2>
      <small>Cadastre as informações principais, TAP inicial e cronograma do projeto.</small>
    </div>
    <button class="icon" type="button" (click)="closeNewProjectModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form class="cp-modal-body" (ngSubmit)="submitProject()">
    <div class="cp-modal-scroll">
      <section class="panel cp-project-panel">
        <div class="cp-form-row">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Nome do projeto</mat-label>
            <input matInput type="text" [(ngModel)]="newProjectForm.name" name="project_name" required>
          </mat-form-field>
        </div>

        <div class="auto-code">
          <strong>Código do projeto</strong>
          <span>Gerado automaticamente após salvar.</span>
        </div>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Descrição</mat-label>
          <textarea matInput rows="3" [(ngModel)]="newProjectForm.description" name="project_description"></textarea>
        </mat-form-field>

        <div class="cp-form-row cp-project-meta-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="newProjectForm.status" name="project_status">
              <mat-option value="DRAFT" *ngIf="editingDraftId">Rascunho</mat-option>
              <mat-option value="PLANNED">Planejado</mat-option>
              <mat-option value="IN_PROGRESS">Em andamento</mat-option>
              <mat-option value="PAUSED">Pausado</mat-option>
              <mat-option value="COMPLETED">Concluído</mat-option>
              <mat-option value="CANCELED">Cancelado</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Gerente</mat-label>
            <mat-select [(ngModel)]="newProjectForm.manager_user_id" name="project_manager">
              <mat-option value="">Selecione o gerente</mat-option>
              <mat-option *ngFor="let user of users" [value]="'' + user.id">{{ user.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="cp-form-row cp-project-meta-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Departamento</mat-label>
            <mat-select [(ngModel)]="newProjectForm.department_id" name="project_department">
              <mat-option value="">Selecione o departamento</mat-option>
              <mat-option *ngFor="let dept of departments" [value]="'' + dept.id">
                {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="cp-form-row cp-project-date-grid">
          <div class="cp-date-field-wrap">
            <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
              <mat-label>Data de início</mat-label>
              <input
                matInput
                type="text"
                name="project_start_display"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                [ngModel]="projectStartDateDisplay"
                (ngModelChange)="onProjectStartDateInput($event)"
                (blur)="onProjectStartDateBlur()">
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de início" (click)="projectStartDatePicker.open()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-error *ngIf="projectStartDateInvalid">Data inválida</mat-error>
            </mat-form-field>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="projectStartDatePicker"
              [ngModel]="projectStartDatePickerValue"
              (dateChange)="onProjectStartDatePicked($event)"
              name="project_start_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #projectStartDatePicker></mat-datepicker>
          </div>

          <div class="cp-date-field-wrap">
            <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
              <mat-label>Data de fim</mat-label>
              <input
                matInput
                type="text"
                name="project_end_display"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                [ngModel]="projectEndDateDisplay"
                (ngModelChange)="onProjectEndDateInput($event)"
                (blur)="onProjectEndDateBlur()">
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de fim" (click)="projectEndDatePicker.open()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-error *ngIf="projectEndDateInvalid">Data inválida</mat-error>
            </mat-form-field>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="projectEndDatePicker"
              [ngModel]="projectEndDatePickerValue"
              (dateChange)="onProjectEndDatePicked($event)"
              name="project_end_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #projectEndDatePicker></mat-datepicker>
          </div>
        </div>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="editingDraftId">
          <mat-label>Justificativa (alteração de datas)</mat-label>
          <textarea matInput rows="2" [(ngModel)]="draftDateReason" name="project_date_reason"></textarea>
        </mat-form-field>

        <div class="tap-card">
          <h3>TAP inicial</h3>

          <div class="cp-form-row tap-grid-two">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Título</mat-label>
              <input matInput type="text" [(ngModel)]="tapForm.title" name="tap_title">
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Objetivos</mat-label>
              <input matInput type="text" [(ngModel)]="tapForm.objectives" name="tap_objectives">
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Justificativa</mat-label>
            <textarea matInput rows="3" [(ngModel)]="tapForm.justification" name="tap_justification"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Escopo de negócio</mat-label>
            <textarea matInput rows="3" [(ngModel)]="tapForm.business_scope" name="tap_business_scope"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Escopo técnico</mat-label>
            <textarea matInput rows="3" [(ngModel)]="tapForm.technical_scope" name="tap_technical_scope"></textarea>
          </mat-form-field>

          <div class="cp-form-row tap-grid-two">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Entregas</mat-label>
              <textarea matInput rows="3" [(ngModel)]="tapForm.deliverables" name="tap_deliverables"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Não entregas</mat-label>
              <textarea matInput rows="3" [(ngModel)]="tapForm.non_deliverables" name="tap_non_deliverables"></textarea>
            </mat-form-field>
          </div>

          <div class="cp-form-row tap-grid-two">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Permissões</mat-label>
              <textarea matInput rows="3" [(ngModel)]="tapForm.permissions" name="tap_permissions"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Restrições</mat-label>
              <textarea matInput rows="3" [(ngModel)]="tapForm.constraints" name="tap_constraints"></textarea>
            </mat-form-field>
          </div>
        </div>
      </section>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeNewProjectModal()">Cancelar</button>
      <button mat-stroked-button type="button" (click)="submitProject(true)">Salvar rascunho</button>
      <button mat-raised-button color="primary" type="submit">{{ editingDraftId ? 'Atualizar projeto' : 'Criar projeto' }}</button>
    </footer>
  </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showTapModal" (click)="closeTapModal()"></div>
<section class="modal-card cp-modal-fixed-height cp-project-tap-modal" *ngIf="showTapModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ editingTapId ? 'Editar TAP' : 'Nova versão do TAP' }}</h2>
      <small>Estruture os objetivos, escopo e critérios para registrar a versão do projeto.</small>
    </div>
    <button class="icon" type="button" (click)="closeTapModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <form class="cp-modal-body" (ngSubmit)="submitTapVersion()">
    <div class="cp-modal-scroll">
      <section class="panel cp-project-modal-panel">
        <div class="cp-form-row cp-tap-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Título</mat-label>
            <input matInput type="text" [(ngModel)]="tapForm.title" name="tap_title_new">
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Objetivos</mat-label>
            <input matInput type="text" [(ngModel)]="tapForm.objectives" name="tap_objectives_new">
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Justificativa</mat-label>
          <textarea matInput rows="4" [(ngModel)]="tapForm.justification" name="tap_justification_new"></textarea>
        </mat-form-field>

        <div class="cp-form-row cp-tap-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Escopo de negócio</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.business_scope" name="tap_business_scope_new"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Escopo técnico</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.technical_scope" name="tap_technical_scope_new"></textarea>
          </mat-form-field>
        </div>

        <div class="cp-form-row cp-tap-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Entregas</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.deliverables" name="tap_deliverables_new"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Não entregas</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.non_deliverables" name="tap_non_deliverables_new"></textarea>
          </mat-form-field>
        </div>

        <div class="cp-form-row cp-tap-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Permissões</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.permissions" name="tap_permissions_new"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Restrições</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.constraints" name="tap_constraints_new"></textarea>
          </mat-form-field>
        </div>

        <div class="cp-form-row cp-tap-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Premissas</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.assumptions" name="tap_assumptions_new"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Riscos</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.risks" name="tap_risks_new"></textarea>
          </mat-form-field>
        </div>

        <div class="cp-form-row cp-tap-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Critérios de sucesso</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.success_criteria" name="tap_success_criteria_new"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Orçamento</mat-label>
            <textarea matInput rows="4" [(ngModel)]="tapForm.budget" name="tap_budget_new"></textarea>
          </mat-form-field>
        </div>
      </section>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeTapModal()">Cancelar</button>
      <button mat-raised-button color="primary" type="submit">{{ editingTapId ? 'Salvar alterações' : 'Salvar versão' }}</button>
    </footer>
  </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showMemberModal" (click)="closeMemberModal()"></div>
<section class="modal-card cp-project-member-modal" *ngIf="showMemberModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Adicionar pessoa</h2>
      <small>Selecione o usuário e defina o perfil no projeto.</small>
    </div>
    <button class="icon" type="button" (click)="closeMemberModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <form class="cp-modal-body" (ngSubmit)="submitMember()">
    <div class="cp-modal-scroll">
      <div class="cp-form-row cp-member-grid">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Pessoa</mat-label>
          <mat-select
            [(ngModel)]="newMemberForm.user_id"
            name="member_user"
            required
            panelClass="controlproject-member-select-panel"
            [disableOptionCentering]="true"
            (openedChange)="onMemberSelectOpened($event)">
            <mat-option class="controlproject-member-search-option" [disabled]="true">
              <div class="controlproject-member-search-box" (click)="$event.stopPropagation()">
                <mat-icon>search</mat-icon>
                <input
                  #memberSearchInput
                  type="search"
                  [(ngModel)]="memberSearch"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Pesquisar usuário"
                  aria-label="Pesquisar usuário"
                  autocomplete="off"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()">
              </div>
            </mat-option>
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let user of filteredMemberUsers()" [value]="user.id">{{ user.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Perfil</mat-label>
          <mat-select [(ngModel)]="newMemberForm.role" name="member_role">
            <mat-option value="MANAGER">Gerente</mat-option>
            <mat-option value="MEMBER">Membro</mat-option>
            <mat-option value="OBSERVER">Observador</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeMemberModal()">Cancelar</button>
      <button mat-raised-button color="primary" type="submit">Adicionar</button>
    </footer>
  </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showMilestoneModal" (click)="closeMilestoneModal()"></div>
<section class="modal-card cp-project-milestone-modal" *ngIf="showMilestoneModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Novo marco</h2>
      <small>Registre um ponto-chave do projeto e acompanhe datas importantes.</small>
    </div>
    <button class="icon" type="button" (click)="closeMilestoneModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <form class="cp-modal-body" (ngSubmit)="submitMilestone()">
    <div class="cp-modal-scroll">
      <section class="panel cp-project-modal-panel">
        <div class="cp-form-row cp-project-date-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Título do marco</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="newMilestoneForm.title"
              name="milestone_title"
              placeholder="Ex: Entrega do protótipo"
              required>
          </mat-form-field>

          <div class="cp-date-field-wrap">
            <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
              <mat-label>Data prevista</mat-label>
              <input
                matInput
                type="text"
                name="milestone_due_date_display"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                [ngModel]="milestoneDueDateDisplay"
                (ngModelChange)="onMilestoneDueDateInput($event)"
                (blur)="onMilestoneDueDateBlur()"
                required>
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de data prevista" (click)="milestoneDueDatePicker.open()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-error *ngIf="milestoneDueDateInvalid">Data inválida</mat-error>
            </mat-form-field>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="milestoneDueDatePicker"
              [ngModel]="milestoneDueDatePickerValue"
              (dateChange)="onMilestoneDueDatePicked($event)"
              name="milestone_due_date_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #milestoneDueDatePicker></mat-datepicker>
          </div>
        </div>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Descrição</mat-label>
          <textarea
            matInput
            rows="4"
            [(ngModel)]="newMilestoneForm.description"
            name="milestone_desc"
            placeholder="Resumo do marco, entregas e expectativas."></textarea>
        </mat-form-field>

        <p class="modal-hint">Os marcos aparecem no calendário e na lista do projeto.</p>
      </section>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeMilestoneModal()">Cancelar</button>
      <button mat-raised-button color="primary" type="submit">Salvar marco</button>
    </footer>
  </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showDateEditModal" (click)="closeDateEditModal()"></div>
<section class="modal-card cp-project-date-edit-modal" *ngIf="showDateEditModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Alterar datas do projeto</h2>
      <small>Atualize o período do projeto e registre uma justificativa.</small>
    </div>
    <button class="icon" type="button" (click)="closeDateEditModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <form class="cp-modal-body" (ngSubmit)="submitDateChange()">
    <div class="cp-modal-scroll">
      <section class="panel cp-project-modal-panel">
        <div class="cp-form-row cp-project-date-grid">
          <div class="cp-date-field-wrap">
            <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
              <mat-label>Data de início</mat-label>
              <input
                matInput
                type="text"
                name="edit_start_date_display"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                [ngModel]="dateEditStartDateDisplay"
                (ngModelChange)="onDateEditStartDateInput($event)"
                (blur)="onDateEditStartDateBlur()">
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de início" (click)="dateEditStartDatePicker.open()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-error *ngIf="dateEditStartDateInvalid">Data inválida</mat-error>
            </mat-form-field>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="dateEditStartDatePicker"
              [ngModel]="dateEditStartDatePickerValue"
              (dateChange)="onDateEditStartDatePicked($event)"
              name="edit_start_date_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #dateEditStartDatePicker></mat-datepicker>
          </div>

          <div class="cp-date-field-wrap">
            <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
              <mat-label>Data de fim</mat-label>
              <input
                matInput
                type="text"
                name="edit_end_date_display"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                [ngModel]="dateEditEndDateDisplay"
                (ngModelChange)="onDateEditEndDateInput($event)"
                (blur)="onDateEditEndDateBlur()">
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de fim" (click)="dateEditEndDatePicker.open()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-error *ngIf="dateEditEndDateInvalid">Data inválida</mat-error>
            </mat-form-field>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="dateEditEndDatePicker"
              [ngModel]="dateEditEndDatePickerValue"
              (dateChange)="onDateEditEndDatePicked($event)"
              name="edit_end_date_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #dateEditEndDatePicker></mat-datepicker>
          </div>
        </div>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Justificativa</mat-label>
          <textarea
            matInput
            rows="4"
            [(ngModel)]="dateEditForm.reason"
            name="edit_reason"
            required></textarea>
        </mat-form-field>
      </section>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeDateEditModal()">Cancelar</button>
      <button mat-raised-button color="primary" type="submit">Salvar alterações</button>
    </footer>
  </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showTaskModal" (click)="closeTaskModal()"></div>
<section class="modal-card cp-project-task-modal" *ngIf="showTaskModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Nova tarefa</h2>
      <small>Cadastre os dados principais da tarefa e organize o contexto do projeto.</small>
    </div>
    <button class="icon" type="button" (click)="closeTaskModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form class="cp-modal-body" [formGroup]="taskForm" (ngSubmit)="submitTask()">
    <div class="cp-modal-scroll">
      <div class="cp-task-modal-layout">
      <section class="panel cp-project-modal-panel cp-task-modal-main">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Título</mat-label>
          <input matInput formControlName="title" type="text" placeholder="Resumo da tarefa">
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Descrição</mat-label>
          <textarea matInput formControlName="description" rows="4" placeholder="Detalhes adicionais"></textarea>
        </mat-form-field>

        <div class="cp-form-row cp-task-grid-3">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
              <mat-option value="OPEN">Aberta</mat-option>
              <mat-option value="IN_PROGRESS">Em andamento</mat-option>
              <mat-option value="BLOCKED">Bloqueada</mat-option>
              <mat-option value="COMPLETED">Concluída</mat-option>
              <mat-option value="AWAITING_CLIENT_RESPONSE">Agdo. Retorno Cliente</mat-option>
              <mat-option value="AWAITING_BUDGET_APPROVAL">Agdo. Aprovação de orçamento</mat-option>
              <mat-option value="AWAITING_SUPPLIER_RESPONSE">Agdo. Retorno Fornecedor</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Visibilidade</mat-label>
            <mat-select formControlName="visibility">
              <mat-option value="PRIVATE">Privada</mat-option>
              <mat-option value="PUBLIC">Pública</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Prioridade</mat-label>
            <mat-select formControlName="priority">
              <mat-option value="LOW">Baixa</mat-option>
              <mat-option value="MEDIUM">Média</mat-option>
              <mat-option value="HIGH">Alta</mat-option>
              <mat-option value="URGENT">Urgente</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="cp-form-row cp-task-grid-2">
          <div class="cp-date-field-wrap">
            <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
              <mat-label>Início</mat-label>
              <input
                matInput
                type="text"
                name="task_start_date_display"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                [ngModel]="taskStartDateDisplay"
                (ngModelChange)="onTaskStartDateInput($event)"
                (blur)="onTaskStartDateBlur()"
                [ngModelOptions]="{ standalone: true }">
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de início da tarefa" (click)="taskStartDatePicker.open()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-error *ngIf="taskStartDateInvalid">Data inválida</mat-error>
            </mat-form-field>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="taskStartDatePicker"
              [ngModel]="taskStartDatePickerValue"
              (dateChange)="onTaskStartDatePicked($event)"
              [ngModelOptions]="{ standalone: true }"
              name="task_start_date_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #taskStartDatePicker></mat-datepicker>
          </div>

          <div class="cp-date-field-wrap">
            <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
              <mat-label>Vencimento</mat-label>
              <input
                matInput
                type="text"
                name="task_due_date_display"
                placeholder="dd/mm/aaaa"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                [ngModel]="taskDueDateDisplay"
                (ngModelChange)="onTaskDueDateInput($event)"
                (blur)="onTaskDueDateBlur()"
                [ngModelOptions]="{ standalone: true }">
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de vencimento da tarefa" (click)="taskDueDatePicker.open()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-error *ngIf="taskDueDateInvalid">Data inválida</mat-error>
            </mat-form-field>
            <input
              matInput
              class="cp-hidden-datepicker-input"
              [matDatepicker]="taskDueDatePicker"
              [ngModel]="taskDueDatePickerValue"
              (dateChange)="onTaskDueDatePicked($event)"
              [ngModelOptions]="{ standalone: true }"
              name="task_due_date_picker_proxy"
              tabindex="-1"
              aria-hidden="true">
            <mat-datepicker #taskDueDatePicker></mat-datepicker>
          </div>
        </div>

        <div class="cp-form-row cp-task-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Grupo</mat-label>
            <mat-select formControlName="groupId" (selectionChange)="handleGroupSelectionChange()">
              <mat-option value="">Selecione</mat-option>
              <mat-option *ngFor="let group of groups" [value]="group.id">{{ group.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="availableFormSubgroups.length">
            <mat-label>Subgrupo</mat-label>
            <mat-select formControlName="subgroupId" (selectionChange)="handleSubgroupSelectionChange()">
              <mat-option value="">Selecione</mat-option>
              <mat-option *ngFor="let subgroup of availableFormSubgroups" [value]="subgroup.id">{{ subgroup.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="bucket-field">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Bucket</mat-label>
            <mat-select formControlName="bucketId" [disabled]="!availableFormBuckets.length">
              <mat-option value="">Selecione</mat-option>
              <mat-option *ngFor="let bucket of availableFormBuckets" [value]="bucket.id">{{ bucket.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <p class="inline-hint" *ngIf="!taskForm.get('subgroupId')?.value">
            Selecione um subgrupo para vincular um bucket.
          </p>
          <div class="inline-bucket-form" *ngIf="taskForm.get('subgroupId')?.value && !availableFormBuckets.length">
            <p class="inline-hint">Nenhum bucket encontrado para este subgrupo. Cadastre um novo.</p>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Nome do novo bucket</mat-label>
              <input matInput type="text" formControlName="inlineBucketName" placeholder="Ex: Backlog">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Descrição (opcional)</mat-label>
              <input matInput type="text" formControlName="inlineBucketDescription" placeholder="Objetivo ou contexto">
            </mat-form-field>
            <button type="button"
                    mat-stroked-button
                    color="primary"
                    (click)="createInlineBucket()"
                    [disabled]="inlineBucketLoading || !taskForm.get('inlineBucketName')?.value?.trim()">
              {{ inlineBucketLoading ? 'Salvando...' : 'Cadastrar bucket' }}
            </button>
          </div>
        </div>

        <div class="cp-form-row cp-task-grid-2">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Tags</mat-label>
            <mat-select formControlName="tagIds" multiple>
              <mat-option *ngFor="let tag of tags" [value]="tag.id">{{ tag.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Responsável</mat-label>
            <mat-select
              formControlName="assigneeId"
              panelClass="controlproject-member-select-panel"
              [disableOptionCentering]="true"
              (openedChange)="onTaskAssigneeSelectOpened($event)">
              <mat-option class="controlproject-member-search-option" [disabled]="true">
                <div class="controlproject-member-search-box" (click)="$event.stopPropagation()">
                  <mat-icon>search</mat-icon>
                  <input
                    #taskAssigneeSearchInput
                    type="search"
                    [ngModel]="taskAssigneeSearch"
                    (ngModelChange)="onTaskAssigneeSearchChange($event)"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Pesquisar na equipe"
                    aria-label="Pesquisar responsável na equipe"
                    autocomplete="off"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()">
                </div>
              </mat-option>
              <mat-option value="">Selecione</mat-option>
              <mat-option *ngFor="let member of filteredTaskAssigneeOptions" [value]="member.id">
                {{ member.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="subtask-creator">
          <label>Subtarefas</label>
          <div class="subtask-input-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Nova subtarefa</mat-label>
              <input matInput type="text" formControlName="newSubtask" placeholder="Descrição da subtarefa">
            </mat-form-field>
            <button type="button" mat-stroked-button color="primary" (click)="addDraftSubtask()">Adicionar</button>
          </div>
          <ul *ngIf="draftSubtasks.length">
            <li *ngFor="let subtask of draftSubtasks; let i = index">
              {{ subtask }}
              <button type="button" (click)="removeDraftSubtask(i)">
                <mat-icon>close</mat-icon>
              </button>
            </li>
          </ul>
        </div>

      </section>

      <aside class="panel cp-project-modal-panel cp-task-modal-side">
        <h4>Anexos</h4>
        <label
          class="dropzone full"
          [class.dragging]="taskModalDragging"
          (dragover)="onTaskDragOver($event)"
          (dragleave)="onTaskDragLeave()"
          (drop)="onTaskDrop($event)">
          <input
            type="file"
            #taskAttachmentInput
            (change)="onTaskFilesSelected($event)"
            multiple>
          <div class="dropzone-content">
            <mat-icon>attach_file</mat-icon>
            <div>
              <strong>Adicionar anexos</strong>
              <span>Arraste e solte aqui ou clique para selecionar</span>
            </div>
          </div>
        </label>

        <ul class="file-list" *ngIf="newTaskFiles.length">
          <li class="file-item" *ngFor="let file of newTaskFiles; let i = index">
            <div class="file-item__thumb" [class.is-image]="isTaskImageFile(file)">
              <img *ngIf="isTaskImageFile(file)" [src]="taskFilePreviewUrl(file)" [alt]="file.name">
              <mat-icon *ngIf="!isTaskImageFile(file)">description</mat-icon>
            </div>
            <div class="file-item__meta">
              <strong class="file-item__name">{{ file.name }}</strong>
              <small>{{ taskFileTypeLabel(file) }} · {{ taskFileSizeLabel(file) }}</small>
            </div>
            <button type="button" (click)="removeTaskFile(i)">Remover</button>
          </li>
        </ul>
      </aside>
      </div>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeTaskModal()">Cancelar</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="taskForm.invalid">Cadastrar tarefa</button>
    </footer>
  </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showTaskDetailModal && activeTask"></div>
<section class="modal-card detail-modal cp-project-task-detail-modal" *ngIf="showTaskDetailModal && activeTask" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Detalhes da tarefa <small *ngIf="activeTask">#{{ activeTask.task_code || '------' }}</small></h2>
        <small>Atualize dados da tarefa, subtarefas, comentários e anexos.</small>
      </div>
      <button class="icon" type="button" (click)="closeTaskDetail()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form class="cp-modal-body" [formGroup]="taskDetailForm" (ngSubmit)="submitTaskDetail()">
      <div class="cp-modal-scroll">
      <div class="detail-body">
        <div class="detail-grid">
          <section class="detail-main">
            <div class="cp-form-row">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Título</mat-label>
                <input matInput type="text" formControlName="title">
              </mat-form-field>
            </div>
            <div class="cp-form-row">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Descrição</mat-label>
                <textarea
                  matInput
                  rows="5"
                  formControlName="description"
                  placeholder="Contextualize a tarefa"></textarea>
              </mat-form-field>
            </div>

            <section class="cp-project-modal-panel detail-card detail-subtasks">
              <header>
                <div class="subtask-header">
                  <div class="subtask-title" *ngIf="activeTask">
                    <h4>Subtarefas</h4>
                    <small>
                      {{ completedSubtasks(activeTask) }}/{{ (activeTask.subtasks || []).length }} concluídas •
                      {{ subtaskProgress(activeTask) | number:'1.0-0' }}%
                    </small>
                  </div>
                  <div class="subtask-progress" *ngIf="activeTask">
                    <div class="progress-bar">
                      <div class="progress" [style.width.%]="subtaskProgress(activeTask)"></div>
                    </div>
                  </div>
                </div>
              </header>
              <div class="subtask-input-row">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Adicionar subtarefa</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="detailSubtaskText"
                    [ngModelOptions]="{ standalone: true }"
                    name="detail-subtask">
                </mat-form-field>
                <button mat-stroked-button type="button" (click)="addDetailSubtask()">Adicionar</button>
              </div>
              <div
                class="subtask-list"
                *ngIf="activeTask?.subtasks?.length"
                cdkDropList
                [cdkDropListData]="activeTask.subtasks"
                (cdkDropListDropped)="reorderDetailSubtasks($event)">
                <div class="subtask-item" *ngFor="let subtask of activeTask?.subtasks" cdkDrag>
                  <label class="subtask-toggle">
                    <input type="checkbox" [checked]="!!subtask.completed" (change)="toggleDetailSubtask(subtask)">
                    <span class="toggle-visual"></span>
                  </label>
                  <button type="button" class="drag-handle" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                  </button>
                  <div class="subtask-info">
                    <p class="title" *ngIf="editingSubtaskId !== subtask.id">{{ subtask.title }}</p>
                    <input
                      *ngIf="editingSubtaskId === subtask.id"
                      class="subtask-edit-input"
                      type="text"
                      [(ngModel)]="editingSubtaskText"
                      [ngModelOptions]="{ standalone: true }">
                    <p class="meta" *ngIf="subtask.due_date; else noSubtaskDate">
                      Vencimento {{ subtask.due_date | date:'dd/MM' }}
                    </p>
                    <ng-template #noSubtaskDate>
                      <p class="meta muted">Sem data definida</p>
                    </ng-template>
                  </div>
                  <button type="button" class="calendar-chip" (click)="openSubtaskDatePicker(datePicker)">
                    <mat-icon>event</mat-icon>
                    <span>
                      {{ subtask.due_date ? (subtask.due_date | date:'dd/MM') : 'Definir data' }}
                    </span>
                  </button>
                  <input
                    #datePicker
                    type="date"
                    class="subtask-date-input"
                    [value]="subtask.due_date ? toInputDate(subtask.due_date) : ''"
                    (click)="$event.stopPropagation()"
                    (change)="updateSubtaskDueDate(subtask, $event)">
                  <div class="subtask-actions">
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingSubtaskId !== subtask.id"
                      (click)="startEditSubtask(subtask)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingSubtaskId === subtask.id"
                      (click)="saveEditSubtask(subtask)">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingSubtaskId === subtask.id"
                      (click)="cancelEditSubtask()">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button type="button" class="icon-btn danger" (click)="deleteSubtask(subtask)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <section class="cp-project-modal-panel detail-card comments-section">
              <header>
                <h4>Comentários</h4>
              </header>
              <textarea
                rows="3"
                class="comment-input"
                [(ngModel)]="detailCommentText"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Compartilhe um comentário"></textarea>
              <div class="comment-tools">
                <div class="file-chip" *ngIf="detailCommentFile">
                  <mat-icon>attach_file</mat-icon>
                  <span>{{ detailCommentFile.name }}</span>
                  <button type="button" class="icon" (click)="removeCommentFile()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
              <div class="comment-actions">
                <button type="button" class="file-btn" (click)="commentFileInput.click()">
                  <mat-icon>attach_file</mat-icon>
                  Anexar
                </button>
                <input
                  type="file"
                  #commentFileInput
                  class="hidden-input"
                  (change)="onCommentFileSelected($event)">
                <button
                  type="button"
                  class="btn ghost"
                  (click)="addDetailComment()"
                  [disabled]="!(detailCommentText.trim() || detailCommentFile)">
                  Enviar
                </button>
              </div>
              <ul class="comment-list" *ngIf="activeTask?.comments?.length; else noComments">
                <li *ngFor="let comment of activeTask?.comments">
                  <div class="comment-header">
                    <strong>{{ comment.author || comment.author_name || 'Colaborador' }}</strong>
                    <span>{{ comment.created_at | date:'short' }}</span>
                  </div>
                  <p class="comment-text" *ngIf="editingCommentId !== comment.id">{{ comment.text || comment.comment }}</p>
                  <textarea
                    *ngIf="editingCommentId === comment.id"
                    class="comment-edit-input"
                    rows="3"
                    [(ngModel)]="editingCommentText"
                    [ngModelOptions]="{ standalone: true }"></textarea>
                  <div class="comment-actions-row">
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingCommentId !== comment.id"
                      (click)="startEditComment(comment)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingCommentId === comment.id"
                      (click)="saveEditComment(comment)">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingCommentId === comment.id"
                      (click)="cancelEditComment()">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button type="button" class="icon-btn danger" (click)="deleteComment(comment)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                  <div class="comment-attachment" *ngIf="comment.attachments?.length || comment.file_path">
                    <a
                      *ngFor="let file of comment.attachments"
                      [href]="formatCommentFile(file.file_path)"
                      target="_blank"
                      rel="noopener">
                      <mat-icon>attach_file</mat-icon>
                      <span>{{ file.file_name || 'Ver arquivo' }}</span>
                    </a>
                    <a
                      *ngIf="!comment.attachments?.length && comment.file_path"
                      [href]="formatCommentFile(comment.file_path)"
                      target="_blank"
                      rel="noopener">
                      <mat-icon>attach_file</mat-icon>
                      <span>{{ comment.file_name || 'Ver arquivo' }}</span>
                    </a>
                  </div>
                </li>
              </ul>
              <ng-template #noComments>
                <p class="empty-hint">Nenhum comentário registrado.</p>
              </ng-template>
            </section>

            <section class="cp-project-modal-panel detail-card task-attachment-section">
              <header>
                <h4>Anexos</h4>
              </header>
              <div class="attachment-list" *ngIf="activeTask?.attachments?.length; else noTaskAttachments">
                <div *ngFor="let file of activeTask?.attachments">
                  <a [href]="taskAttachmentUrl(file)" target="_blank" rel="noopener">
                    <mat-icon>attach_file</mat-icon>
                    <span>{{ file.file_name || 'Ver arquivo' }}</span>
                  </a>
                  <small>
                    {{ userNameById(file.uploaded_by) }} · {{ file.uploaded_at | date:'short' }}
                  </small>
                </div>
              </div>
              <ng-template #noTaskAttachments>
                <p class="empty-hint">Nenhum anexo registrado.</p>
              </ng-template>
            </section>

          </section>
          <aside class="detail-side">
            <section class="cp-project-modal-panel config-card">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                  <mat-option value="OPEN">Aberta</mat-option>
                  <mat-option value="IN_PROGRESS">Em andamento</mat-option>
                  <mat-option value="BLOCKED">Bloqueada</mat-option>
                  <mat-option value="COMPLETED">Concluída</mat-option>
                  <mat-option value="AWAITING_CLIENT_RESPONSE">Agdo. Retorno Cliente</mat-option>
                  <mat-option value="AWAITING_BUDGET_APPROVAL">Agdo. Aprovação de orçamento</mat-option>
                  <mat-option value="AWAITING_SUPPLIER_RESPONSE">Agdo. Retorno Fornecedor</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Prioridade</mat-label>
                <mat-select formControlName="priority">
                  <mat-option value="LOW">Baixa</mat-option>
                  <mat-option value="MEDIUM">Média</mat-option>
                  <mat-option value="HIGH">Alta</mat-option>
                  <mat-option value="URGENT">Urgente</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Visibilidade</mat-label>
                <mat-select formControlName="visibility">
                  <mat-option value="PRIVATE">Privada</mat-option>
                  <mat-option value="PUBLIC">Pública</mat-option>
                </mat-select>
              </mat-form-field>

              <div class="cp-date-field-wrap">
                <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
                  <mat-label>Início</mat-label>
                  <input
                    matInput
                    type="text"
                    name="task_detail_start_date_display"
                    placeholder="dd/mm/aaaa"
                    inputmode="numeric"
                    maxlength="10"
                    autocomplete="off"
                    [ngModel]="taskDetailStartDateDisplay"
                    (ngModelChange)="onTaskDetailStartDateInput($event)"
                    (blur)="onTaskDetailStartDateBlur()"
                    [ngModelOptions]="{ standalone: true }">
                  <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de início" (click)="taskDetailStartDatePicker.open()">
                    <mat-icon>calendar_today</mat-icon>
                  </button>
                  <mat-error *ngIf="taskDetailStartDateInvalid">Data inválida</mat-error>
                </mat-form-field>
                <input
                  matInput
                  class="cp-hidden-datepicker-input"
                  [matDatepicker]="taskDetailStartDatePicker"
                  [ngModel]="taskDetailStartDatePickerValue"
                  (dateChange)="onTaskDetailStartDatePicked($event)"
                  [ngModelOptions]="{ standalone: true }"
                  name="task_detail_start_date_picker_proxy"
                  tabindex="-1"
                  aria-hidden="true">
                <mat-datepicker #taskDetailStartDatePicker></mat-datepicker>
              </div>

              <div class="cp-date-field-wrap">
                <mat-form-field appearance="outline" floatLabel="always" class="digital-field modal-standard-field">
                  <mat-label>Fim</mat-label>
                  <input
                    matInput
                    type="text"
                    name="task_detail_due_date_display"
                    placeholder="dd/mm/aaaa"
                    inputmode="numeric"
                    maxlength="10"
                    autocomplete="off"
                    [ngModel]="taskDetailDueDateDisplay"
                    (ngModelChange)="onTaskDetailDueDateInput($event)"
                    (blur)="onTaskDetailDueDateBlur()"
                    [ngModelOptions]="{ standalone: true }">
                  <button mat-icon-button matSuffix type="button" aria-label="Abrir calendário de vencimento" (click)="taskDetailDueDatePicker.open()">
                    <mat-icon>calendar_today</mat-icon>
                  </button>
                  <mat-error *ngIf="taskDetailDueDateInvalid">Data inválida</mat-error>
                </mat-form-field>
                <input
                  matInput
                  class="cp-hidden-datepicker-input"
                  [matDatepicker]="taskDetailDueDatePicker"
                  [ngModel]="taskDetailDueDatePickerValue"
                  (dateChange)="onTaskDetailDueDatePicked($event)"
                  [ngModelOptions]="{ standalone: true }"
                  name="task_detail_due_date_picker_proxy"
                  tabindex="-1"
                  aria-hidden="true">
                <mat-datepicker #taskDetailDueDatePicker></mat-datepicker>
              </div>
            </section>

            <section class="cp-project-modal-panel config-card">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Grupos</mat-label>
                <mat-select formControlName="groupId" (selectionChange)="handleDetailGroupChange()">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let group of groups" [value]="group.id">{{ group.name }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="detailFormSubgroups.length">
                <mat-label>Subgrupo</mat-label>
                <mat-select formControlName="subgroupId" (selectionChange)="handleDetailSubgroupChange()">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let subgroup of detailFormSubgroups" [value]="subgroup.id">{{ subgroup.name }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="detailFormBuckets.length">
                <mat-label>Bucket</mat-label>
                <mat-select formControlName="bucketId">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let bucket of detailFormBuckets" [value]="bucket.id">{{ bucket.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </section>

            <section class="cp-project-modal-panel config-card">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Responsável</mat-label>
                <mat-select
                  formControlName="assigneeId"
                  panelClass="controlproject-member-select-panel"
                  [disableOptionCentering]="true"
                  (openedChange)="onTaskAssigneeSelectOpened($event, true)">
                  <mat-option class="controlproject-member-search-option" [disabled]="true">
                    <div class="controlproject-member-search-box" (click)="$event.stopPropagation()">
                      <mat-icon>search</mat-icon>
                      <input
                        #taskDetailAssigneeSearchInput
                        type="search"
                        [ngModel]="taskDetailAssigneeSearch"
                        (ngModelChange)="onTaskAssigneeSearchChange($event, true)"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Pesquisar na equipe"
                        aria-label="Pesquisar responsável na equipe"
                        autocomplete="off"
                        (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()">
                    </div>
                  </mat-option>
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let member of filteredTaskDetailAssigneeOptions" [value]="member.id">
                    {{ member.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Tags</mat-label>
                <mat-select formControlName="tagIds" multiple>
                  <mat-option *ngFor="let tag of tags" [value]="tag.id">{{ tag.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </section>
          </aside>
        </div>
      </div>
      </div>
      <footer class="entry-footer">
        <button mat-stroked-button type="button" class="task-delete-btn" (click)="deleteTask(activeTask)">Excluir tarefa</button>
        <button mat-stroked-button type="button" (click)="closeTaskDetail()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="taskDetailForm.invalid">Salvar alterações</button>
      </footer>
    </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showNewTicketModal" (click)="closeNewTicket()"></div>
<section class="modal-card cp-project-ticket-modal" *ngIf="showNewTicketModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Novo chamado</h2>
      <small>Registre o chamado do projeto e anexe evidências necessárias.</small>
    </div>
    <button class="icon" type="button" (click)="closeNewTicket()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <form class="cp-modal-body" (ngSubmit)="submitTicket()">
    <div class="cp-modal-scroll">
      <div class="cp-ticket-modal-layout">
        <section class="panel cp-project-modal-panel cp-ticket-modal-main">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Título</mat-label>
            <input matInput type="text" [(ngModel)]="newTicketForm.title" name="ticket_title" required>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Descrição</mat-label>
            <textarea matInput rows="4" [(ngModel)]="newTicketForm.description" name="ticket_description" required></textarea>
          </mat-form-field>

          <div class="cp-form-row cp-ticket-grid-2">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Prioridade</mat-label>
              <mat-select [(ngModel)]="newTicketForm.priority" name="ticket_priority">
                <mat-option value="LOW">Baixa</mat-option>
                <mat-option value="MEDIUM">Média</mat-option>
                <mat-option value="HIGH">Alta</mat-option>
                <mat-option value="URGENT">Urgente</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Origem</mat-label>
              <mat-select [(ngModel)]="newTicketForm.origin_department_id" name="ticket_origin" required>
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let dept of originDepartments()" [value]="dept.id">
                  {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="cp-form-row cp-ticket-grid-3">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Departamento</mat-label>
              <mat-select [(ngModel)]="newTicketForm.department_id" name="ticket_department" required (ngModelChange)="onDepartmentChange()">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let dept of departments" [value]="dept.id">
                  {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Categoria</mat-label>
              <mat-select [(ngModel)]="newTicketForm.category" name="ticket_category" [disabled]="!newTicketForm.department_id">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let cat of categoriesByDepartment()" [value]="cat.name">{{ cat.name }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Subcategoria</mat-label>
              <mat-select [(ngModel)]="newTicketForm.subcategory" name="ticket_subcategory" [disabled]="!newTicketForm.department_id || !newTicketForm.category">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let sub of subcategoriesByDepartment()" [value]="sub">{{ sub }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>

        <aside class="panel cp-project-modal-panel cp-ticket-modal-side">
          <h4>Anexos</h4>
          <label
            class="dropzone full"
            [class.dragging]="draggingNewTicket"
            (dragover)="onNewTicketDragOver($event)"
            (dragleave)="onNewTicketDragLeave()"
            (drop)="onNewTicketDrop($event)">
            <input type="file" #ticketAttachmentInput (change)="onNewTicketFileSelect($event)" multiple>
            <div class="dropzone-content">
              <mat-icon>attach_file</mat-icon>
              <div>
                <strong>Adicionar anexos</strong>
                <span>Arraste e solte aqui ou clique para selecionar</span>
              </div>
            </div>
          </label>

          <div class="file-list" *ngIf="newTicketFiles.length">
            <div class="file-item" *ngFor="let file of newTicketFiles; let i = index">
              <span>{{ file.name }}</span>
              <button type="button" (click)="removeNewTicketFile(i)">Remover</button>
            </div>
          </div>
        </aside>
      </div>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeNewTicket()">Cancelar</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="savingNewTicket">
        {{ savingNewTicket ? 'Salvando...' : 'Salvar chamado' }}
      </button>
    </footer>
  </form>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showTicketDetail" (click)="closeTicketDetail()"></div>
<section class="modal-card detail-modal cp-modal-fixed-height cp-project-ticket-detail-modal" *ngIf="showTicketDetail && activeTicket" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ activeTicket.title }}</h2>
      <small>{{ activeTicket.ticket_code }} · {{ activeTicket.related_module }} · {{ ticketViewLabel() }}</small>
    </div>
    <div class="ticket-detail-actions">
      <button
        *ngIf="canDeleteTicket(activeTicket) && deletingTicketId !== activeTicket.id"
        class="icon danger"
        type="button"
        (click)="deleteTicket(activeTicket, $event)">
        <mat-icon>delete</mat-icon>
      </button>
      <button class="icon" type="button" (click)="closeTicketDetail()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>
  <div class="cp-modal-body">
    <nav class="cp-tabs cp-ticket-detail-tabs">
      <button mat-stroked-button type="button" [class.active]="ticketDetailTab === 'details'" (click)="ticketDetailTab = 'details'">
        <mat-icon>info</mat-icon>
        Detalhes
      </button>
      <button mat-stroked-button type="button" [class.active]="ticketDetailTab === 'comments'" (click)="ticketDetailTab = 'comments'">
        <mat-icon>chat</mat-icon>
        Comentários
      </button>
      <button mat-stroked-button type="button" [class.active]="ticketDetailTab === 'history'" (click)="ticketDetailTab = 'history'">
        <mat-icon>history</mat-icon>
        Histórico
      </button>
      <button mat-stroked-button type="button" [class.active]="ticketDetailTab === 'attachments'" (click)="ticketDetailTab = 'attachments'">
        <mat-icon>attach_file</mat-icon>
        Anexos
      </button>
    </nav>
    <div class="cp-modal-scroll">

      <section class="panel cp-project-modal-panel cp-ticket-tab-panel" *ngIf="ticketDetailTab === 'details'">
        <p class="ticket-description">{{ activeTicket.description }}</p>
        <div class="meta-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Status</mat-label>
            <mat-select [ngModel]="activeTicket.status" (ngModelChange)="changeStatus($event)" name="detail_status">
              <mat-option value="OPEN">Aberto</mat-option>
              <mat-option value="IN_PROGRESS">Em andamento</mat-option>
              <mat-option value="WAITING_USER">Aguardando usuário</mat-option>
              <mat-option value="WAITING_THIRD_PARTY">Aguardando terceiro</mat-option>
              <mat-option value="RESOLVED">Resolvido</mat-option>
              <mat-option value="CLOSED">Fechado</mat-option>
              <mat-option value="CANCELED">Cancelado</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Prioridade</mat-label>
            <mat-select [ngModel]="activeTicket.priority" (ngModelChange)="changePriority($event)" name="detail_priority">
              <mat-option value="LOW">Baixa</mat-option>
              <mat-option value="MEDIUM">Média</mat-option>
              <mat-option value="HIGH">Alta</mat-option>
              <mat-option value="URGENT">Urgente</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Responsável</mat-label>
            <mat-select [ngModel]="activeTicket.assigned_to" (ngModelChange)="assignTicket($event)" name="detail_assigned">
              <mat-option value="">Sem responsável</mat-option>
              <mat-option *ngFor="let user of users" [value]="user.id">{{ user.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Prazo</mat-label>
            <input matInput type="datetime-local" [ngModel]="formatDateTimeLocal(activeTicket.due_at)" (ngModelChange)="changeDueAt($event)" name="detail_due_at">
          </mat-form-field>
        </div>

        <section class="cp-project-modal-panel detail-card watchers" *ngIf="canEditActiveTicket()">
          <strong>Observadores</strong>
          <div class="watcher-list">
            <span class="pill" *ngFor="let watcher of ticketWatchers">
              {{ watcher }}
              <button type="button" (click)="removeWatcher(watcher)">×</button>
            </span>
          </div>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Adicionar observador</mat-label>
            <mat-select (selectionChange)="addWatcher($event.value)">
              <mat-option value="">Selecione</mat-option>
              <mat-option *ngFor="let user of users" [value]="user.id">{{ user.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </section>
      </section>

      <section class="panel cp-project-modal-panel cp-ticket-tab-panel" *ngIf="ticketDetailTab === 'comments'">
        <form class="comment-form" (ngSubmit)="addComment()">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Comentário</mat-label>
            <textarea matInput rows="4" [(ngModel)]="newCommentForm.comment" name="new_comment" placeholder="Adicionar comentário"></textarea>
          </mat-form-field>
          <div class="comment-actions">
            <label class="checkbox">
              <input type="checkbox" [(ngModel)]="newCommentForm.is_internal" name="internal_comment">
              Comentário interno
            </label>
            <button type="button" mat-stroked-button (click)="ticketDetailCommentFileInput.click()">Anexar arquivo</button>
            <input type="file" #ticketDetailCommentFileInput class="hidden-input" (change)="onTicketCommentFileSelected($event)">
            <button mat-raised-button color="primary" type="submit">Enviar comentário</button>
          </div>
        </form>

        <div class="comment-list">
          <article *ngFor="let comment of ticketComments">
            <header>
              <strong>{{ comment.user_name || userNameById(comment.user_id) }}</strong>
              <small>{{ comment.created_at | date:'short' }}</small>
            </header>
            <p>{{ comment.comment }}</p>
            <span class="pill" *ngIf="comment.is_internal">Interno</span>
            <div class="comment-attachments" *ngIf="commentAttachments(comment.id).length">
              <div class="comment-attachment" *ngFor="let file of commentAttachments(comment.id)">
                <a [href]="fileUrl(file)" target="_blank">{{ file.file_name }}</a>
                <small>{{ file.uploaded_at | date:'short' }}</small>
              </div>
            </div>
          </article>
          <p class="empty" *ngIf="!ticketComments.length">Nenhum comentário ainda.</p>
        </div>
      </section>

      <section class="panel cp-project-modal-panel cp-ticket-tab-panel" *ngIf="ticketDetailTab === 'history'">
        <div class="section-header">
          <strong>Histórico</strong>
          <span class="hint">Linha do tempo do chamado</span>
        </div>
        <div class="history-list">
          <article *ngFor="let item of ticketHistory">
            <div class="history-dot"></div>
            <div class="history-content">
              <div class="history-title">{{ historyLabel(item) }}</div>
              <div class="history-meta">
                <span>{{ item.user_name || userNameById(item.user_id) }}</span>
                <small>{{ item.created_at | date:'dd/MM/yyyy HH:mm' }}</small>
              </div>
            </div>
          </article>
          <p class="empty" *ngIf="!ticketHistory.length">Sem histórico disponível.</p>
        </div>
      </section>

      <section class="panel cp-project-modal-panel cp-ticket-tab-panel" *ngIf="ticketDetailTab === 'attachments'">
        <label
          class="dropzone full"
          [class.dragging]="draggingTicketDetailAttachment"
          (dragover)="onTicketDetailAttachmentDragOver($event)"
          (dragleave)="onTicketDetailAttachmentDragLeave()"
          (drop)="onTicketDetailAttachmentDrop($event)">
          <input type="file" (change)="addAttachment($event)" multiple>
          <div class="dropzone-content">
            <mat-icon>attach_file</mat-icon>
            <div>
              <strong>Adicionar anexos</strong>
              <span>Arraste e solte aqui ou clique para selecionar</span>
            </div>
          </div>
        </label>

        <div class="attachment-list">
          <div *ngFor="let file of standaloneAttachments()">
            <a [href]="fileUrl(file)" target="_blank">{{ file.file_name }}</a>
            <small>{{ file.uploaded_by_name || userNameById(file.uploaded_by) }} · {{ file.uploaded_at | date:'short' }}</small>
          </div>
          <p class="empty" *ngIf="!standaloneAttachments().length">Nenhum anexo.</p>
        </div>
      </section>
    </div>

    <footer class="entry-footer">
      <button mat-stroked-button type="button" (click)="closeTicketDetail()">Fechar</button>
    </footer>
  </div>
</section>

<div class="cp-modal-backdrop modal-backdrop" *ngIf="showMilestoneDeleteModal" (click)="cancelMilestoneDelete()"></div>
<section class="modal-card cp-standard-modal milestone-delete-modal" *ngIf="showMilestoneDeleteModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Excluir marco</h2>
      <p class="modal-subtitle">Confirme a remoção do marco selecionado.</p>
    </div>
    <button class="icon-button" type="button" (click)="cancelMilestoneDelete()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="cp-modal__body">
    <p class="delete-modal-copy">
      Deseja excluir <strong>{{ milestoneToDelete?.title || 'este marco' }}</strong>? Esta ação não pode ser desfeita.
    </p>
  </div>
  <footer class="cp-modal__footer">
    <button class="btn outline" type="button" (click)="cancelMilestoneDelete()">Cancelar</button>
    <button class="btn danger" type="button" (click)="confirmMilestoneDelete()">Excluir</button>
  </footer>
</section>
